import * as Redux from 'redux';
import { ReduxPromiseAction, SimpleResponse } from '../app/app.types';
import { callApi } from '../util/ApiCaller';
import { AdminResponse, AdminActionsType, EmailBlastFilters } from './admin.types';
import {
  GET_BUSINESS_LIST,
  IMPERSONATE,
  GET_LOCKED_ACCOUNTS,
  EMAIL_BLAST,
  IMPORT_CSV
} from './admin.constants';
import { pickAuthOrImpersonationToken } from '../util/token.util';

export const getBusinessList: Redux.ActionCreator<
  ReduxPromiseAction<
    AdminActionsType, SimpleResponse<AdminResponse>
  >
> = (): ReduxPromiseAction<AdminActionsType, SimpleResponse<AdminResponse>> => ({
  type: GET_BUSINESS_LIST,
  payload: callApi(
    process.env.REACT_APP_API + '/business/list',
    true,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      }
    }
  )
});

export const impersonate: Redux.ActionCreator<
  ReduxPromiseAction<
    AdminActionsType, SimpleResponse<AdminResponse>
  >
> = (accountId: number): ReduxPromiseAction<AdminActionsType, SimpleResponse<AdminResponse>> => ({
  type: IMPERSONATE,
  payload: callApi(
    process.env.REACT_APP_API + '/log/impersonation',
    true,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      },
      body: JSON.stringify({accountId})
    }
  )
});

export const getLockedAccounts: Redux.ActionCreator<
  ReduxPromiseAction<
    AdminActionsType, SimpleResponse<AdminResponse>
  >
> = (): ReduxPromiseAction<AdminActionsType, SimpleResponse<AdminResponse>> => ({
  type: GET_LOCKED_ACCOUNTS,
  payload: callApi(
    process.env.REACT_APP_API + '/admin/accounts/locked',
    true,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      }
    }
  )
});

export const unlockAccount: Redux.ActionCreator<
  ReduxPromiseAction<
    AdminActionsType, SimpleResponse<AdminResponse>
  >
> = (id: number): ReduxPromiseAction<AdminActionsType, SimpleResponse<AdminResponse>> => ({
  type: GET_LOCKED_ACCOUNTS,
  payload: callApi(
    process.env.REACT_APP_API + '/admin/unlock/' + id,
    true,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      }
    }
  )
});

export const emailBlast: Redux.ActionCreator<
  ReduxPromiseAction<
    AdminActionsType, SimpleResponse<AdminResponse>
  >
> = (
  subject: string, 
  emailBody: string, 
  filters?: EmailBlastFilters
): ReduxPromiseAction<AdminActionsType, SimpleResponse<AdminResponse>> => ({
  type: EMAIL_BLAST,
  payload: callApi(
    process.env.REACT_APP_API + '/admin/emailblast',
    true,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      },
      body: JSON.stringify({
        subject: subject,
        emailBody: emailBody,
        filters: filters ?
          {
            city: filters.city,
            province: filters.province,
            country: filters.country,
            businessType: filters.businessType
          } :
          undefined
      })
    }
  )
});

export const importCSVAction: Redux.ActionCreator<
  ReduxPromiseAction<
    AdminActionsType, SimpleResponse<AdminResponse>
  >
> = (file: File): ReduxPromiseAction<AdminActionsType, SimpleResponse<AdminResponse>> => ({
  type: IMPORT_CSV,
  payload: callApi(
    process.env.REACT_APP_API + '/admin/emailblast/prospects',
    true,
    {
      method: 'POST',
      headers: {
        'Authorization': pickAuthOrImpersonationToken()
      },
      body: ((): FormData => {
        let formData = new FormData();
        formData.append('file', (file) ? file : '');

        return formData;
      })()
    }
  )
});



// WEBPACK FOOTER //
// ./src/admin/admin.actions.tsx